import { GqlPlannerVisitStatus } from "~/__generated__";

import { TimeReportsTableHeader } from "../TimeReportTableHeader";
import { TimeReportTableRow, TimeReportValues } from "../TimeReportTableRow";
import { TimeReportTableRowFragment } from "../TimeReportTableRow/fragments.generated";

type Props = {
    reports: TimeReportTableRowFragment[];
    visitStatus: GqlPlannerVisitStatus;
    onUpdate: (reportId: string, values: TimeReportValues) => void;
};

export default function TimeReportsList({ reports, visitStatus, onUpdate }: Props) {
    return (
        <>
            <TimeReportsTableHeader />
            {reports.map(report => (
                <TimeReportTableRow
                    key={report.id}
                    report={report}
                    visitStatus={visitStatus}
                    onUpdate={(reportId, values) => onUpdate(reportId, values)}
                />
            ))}
        </>
    );
}
